module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel02_1280_1280_ja-2449e4767ba144375e53fcefc60c47ae.jpg";